"use client";
import { jsx as t, jsxs as s, Fragment as D } from "react/jsx-runtime";
import _ from "clsx";
import M from "next/image";
import I from "next/link";
import { memo as N, useCallback as T } from "react";
import { Button as q } from "../../../buttons/button/Button.js";
import { Box as o } from "../../base/Base.js";
import '../../../assets/CoinPack2.css';const z = "_list_1ruxx_1", A = "__disabled_1ruxx_8", E = "_item_1ruxx_30", G = "_bg_1ruxx_43", H = "_redesign_1ruxx_58", J = "_cost_1ruxx_68", K = "_description_1ruxx_68", O = "_coins__discount_1ruxx_71", Q = "_vip_1ruxx_77", R = "__flat_1ruxx_77", S = "_free_1ruxx_100", U = "_vip_for_nudiva_1ruxx_114", V = "__loading_1ruxx_132", W = "_image_1ruxx_144", X = "__active_1ruxx_168", Y = "_method_1ruxx_190", Z = "_logo_1ruxx_278", $ = "_text_1ruxx_284", ee = "_label_1ruxx_292", te = "_badge_box_1ruxx_307", _e = "_discount_1ruxx_315", se = "__green_1ruxx_324", ce = "_discount__icon_1ruxx_328", oe = "_hot_icon_1ruxx_331", ne = "__centered_1ruxx_363", ae = "_cost__discount_1ruxx_367", ie = "_coins_1ruxx_71", re = "_num_1ruxx_393", le = "_icon_1ruxx_402", de = "_discount_plate_1ruxx_428", xe = "_hot_plate_1ruxx_450", e = {
  list: z,
  _disabled: A,
  item: E,
  bg: G,
  redesign: H,
  cost: J,
  description: K,
  coins__discount: O,
  vip: Q,
  _flat: R,
  free: S,
  vip_for_nudiva: U,
  _loading: V,
  image: W,
  _active: X,
  method: Y,
  logo: Z,
  text: $,
  label: ee,
  badge_box: te,
  discount: _e,
  _green: se,
  discount__icon: ce,
  hot_icon: oe,
  _centered: ne,
  cost__discount: ae,
  coins: ie,
  num: re,
  icon: le,
  discount_plate: de,
  hot_plate: xe
}, me = N(
  ({ disabled: i, children: n }) => /* @__PURE__ */ t("div", { className: _(e.list, { [e._disabled]: i }), children: n })
);
me.displayName = "CoinPackList";
const ue = N(
  ({
    href: i,
    target: n,
    onClick: d,
    hot: g,
    discount: r,
    imageBg: x,
    imageBgMeta: m,
    type: c = "vip",
    coins: l,
    coins_with_discount: u,
    text: v,
    icon: a,
    price: p,
    price_with_discount: h,
    event: y = "none",
    flat: B,
    active: C,
    loading: f,
    disabled: b,
    scroll: F = !1,
    ...P
  }) => {
    const w = (j) => {
      if (f || b) {
        j.preventDefault();
        return;
      }
      d == null || d(j);
    }, L = _(e.item, e[c], e[y], {
      [e._flat]: B,
      [e._active]: C,
      [e._loading]: f,
      [e._disabled]: b
    }), k = /* @__PURE__ */ s(D, { children: [
      /* @__PURE__ */ t("div", { className: e.bg }),
      x && /* @__PURE__ */ t(
        M,
        {
          src: x,
          className: e.image,
          alt: m || "",
          width: 202,
          height: 136
        }
      ),
      p ? /* @__PURE__ */ s(D, { children: [
        /* @__PURE__ */ s(o, { row: !0, className: e.badge_box, children: [
          r && r > 0 ? /* @__PURE__ */ s(
            o,
            {
              gap: 4,
              row: !0,
              center: !0,
              className: _(e.discount, {
                [e._green]: u
              }),
              children: [
                h ? "-" : "+",
                r,
                "%",
                " ",
                !h && /* @__PURE__ */ t(
                  "span",
                  {
                    className: _("material-icons", e.discount__icon),
                    "data-icon": c === "free" ? "star" : "diamond"
                  }
                )
              ]
            }
          ) : null,
          g && /* @__PURE__ */ t(
            "div",
            {
              className: _("material-icons", e.hot_icon),
              "data-icon": "local_fire_department"
            }
          )
        ] }),
        /* @__PURE__ */ s(
          o,
          {
            gap: 8,
            row: !0,
            className: _(e.cost, {
              [e._centered]: !g && !r
            }),
            children: [
              p,
              h && /* @__PURE__ */ t("div", { className: e.cost__discount, children: h })
            ]
          }
        )
      ] }) : /* @__PURE__ */ t(o, { center: !0, className: e.description, children: v }),
      /* @__PURE__ */ s(o, { gap: 4, className: _(e.coins, e[c]), children: [
        u && /* @__PURE__ */ s(
          o,
          {
            gap: 4,
            row: !0,
            className: _(e.coins__discount, e[c]),
            children: [
              /* @__PURE__ */ t("div", { className: e.num, children: u }),
              /* @__PURE__ */ t(
                "div",
                {
                  className: _("material-icons", e.icon),
                  "data-icon": a || (c === "free" ? "star" : "diamond")
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ s(o, { gap: 4, row: !0, center: !0, children: [
          /* @__PURE__ */ t("div", { className: e.num, children: l }),
          /* @__PURE__ */ t(
            "div",
            {
              className: _("material-icons", e.icon),
              "data-icon": a || (c === "free" ? "star" : "diamond")
            }
          )
        ] })
      ] })
    ] });
    return i ? /* @__PURE__ */ t(
      I,
      {
        href: i,
        target: n,
        scroll: F,
        className: L,
        onClick: w,
        ...P,
        children: k
      }
    ) : /* @__PURE__ */ t("div", { className: L, onClick: w, ...P, children: k });
  }
);
ue.displayName = "CoinPack";
const ge = N(
  ({
    hot: i,
    discount: n,
    imageBg: d,
    active: g,
    name: r,
    label: x,
    loading: m,
    disabled: c,
    onClick: l,
    ...u
  }) => {
    const v = T(
      (a) => {
        if (m || c) {
          a.preventDefault();
          return;
        }
        l == null || l(a);
      },
      [m, c, l]
    );
    return /* @__PURE__ */ s(
      q,
      {
        className: _(e.method, {
          [e._active]: g,
          [e._loading]: m,
          [e._disabled]: c
        }),
        onClick: v,
        wide: !0,
        centerText: !0,
        color: "none",
        ...u,
        children: [
          /* @__PURE__ */ t("div", { className: e.bg }),
          /* @__PURE__ */ s(o, { row: !0, className: e.badge_box, children: [
            n && n > 0 ? /* @__PURE__ */ s("div", { className: e.discount, children: [
              "-",
              n,
              "%"
            ] }) : null,
            i && /* @__PURE__ */ t(
              "div",
              {
                className: _("material-icons", e.hot_icon),
                "data-icon": "local_fire_department"
              }
            )
          ] }),
          /* @__PURE__ */ t(
            M,
            {
              src: d,
              alt: "",
              className: e.logo,
              width: 152,
              height: 64
            }
          ),
          /* @__PURE__ */ t("div", { className: e.text, children: r }),
          x && /* @__PURE__ */ t("div", { className: e.label, children: x })
        ]
      }
    );
  }
);
ge.displayName = "PaymentMethod";
export {
  ue as CoinPack,
  me as CoinPackList,
  ge as PaymentMethod
};
